/* eslint-disable no-prototype-builtins */
import React from 'react';
import { Badge } from 'reactstrap';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';
import getContactName, { getContactNameForAvatar } from '../../../utils/functions';

const renderListContacts = (list_contacts_id, contacts, isViewOnly = false) => {
  if (!list_contacts_id) return null;
  console.log('list contacts id is: ', list_contacts_id);
  if (contacts && list_contacts_id.length > 0 && !isViewOnly) {
    return (
      list_contacts_id.map((contactId) => {
        let userId = contactId;
        if (contactId && contactId._id) {
          userId = contactId._id;
        }
        return (
          <Avatar key={userId} style={{ marginRight: -6, fontWeight: 'bold' }} size="30" round title={getContactName(contacts, userId)} name={getContactNameForAvatar(contacts, userId)} />
        );
      })
    );
  }
  if (isViewOnly) {
    return (
      <div>
        <Badge color="success">{list_contacts_id.length} contacts</Badge>
      </div>
    );
  }
  return (
    <div>
      <Badge color="warning">Aucun contact désigné</Badge>
    </div>
  );
};

const renderListAccesses = (data, accesses, contacts, isBeneficiary = false, isViewOnly = false) => {
  const endList = [];
  const { category, contacts: list_contacts } = data;
  if (isBeneficiary && list_contacts) {
    // must display beneficiaries
    list_contacts.forEach((e) => {
      endList.push({
        title: getContactName(contacts, e),
        name: getContactNameForAvatar(contacts, e),
        key: e,
      });
    });
  } else if (!isBeneficiary && accesses && accesses.length > 0 && !isViewOnly) {
    // must display contacts that shall receive the information
    accesses.forEach((e) => {
      if (e.permissions && e.permissions.hasOwnProperty(category) && e.permissions[category] !== 'never') {
        endList.push({
          title: getContactName(contacts, e.contact_id),
          name: getContactNameForAvatar(contacts, e.contact_id),
          key: e.contact_id,
        });
      }
    });
  }
  if (endList.length > 0) {
    if (isViewOnly) {
      return (
        <div>
          <Badge color="success">{endList.length} contacts associés</Badge>
        </div>
      );
    }
    return (
      <div>
        {
          endList.map(e => (
            <Avatar key={e.key} title={e.title} style={{ marginRight: -6, fontWeight: 'bold' }} size="30" round name={e.name} />
          ))
        }
      </div>
    );
  }
  return (
    <div>
      <Badge color="warning">Aucun contact désigné</Badge>
    </div>
  );
};

// const listAssetsWithContacts = ['cloud', 'insurance'];

const AssetModalContacts = ({
  data,
  contacts,
  isPermalink,
  isCrypto,
  accesses,
  isBeneficiary,
  isMemorial,
  isViewOnly,
}) => {
  if (isPermalink || isCrypto || isMemorial) {
    return renderListContacts(data.contacts, contacts, isViewOnly);
  }
  if (data.subcategory === 'crypto_currency' && data.secureKeyChoice === 'legitbee') {
    return null;
  }
  if (!data.permalinks || data.permalinks.length === 0) {
    let textContacts = 'Qui recevra l\'information';
    if (data.subcategory === 'crypto_currency') textContacts = 'Partagée entre :';
    else if (isBeneficiary) textContacts = 'Bénéficiaires';
    if (!isBeneficiary && isViewOnly) return null; // cacher la liste de ceux à qui l'information est transmise => confidentiel
    return (
      <div className="mt-20">
        <div className="leftInfo">
          <h5 className="bold-text">{textContacts}</h5>
        </div>
        <div className="rightInfo">
          {renderListAccesses(data, accesses, contacts, isBeneficiary, isViewOnly)}
        </div>
      </div>
    );
  }
  return null;
};

AssetModalContacts.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isPermalink: PropTypes.bool,
  isCrypto: PropTypes.bool,
  isBeneficiary: PropTypes.bool,
  isMemorial: PropTypes.bool,
  isViewOnly: PropTypes.bool,
  contacts: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  accesses: PropTypes.arrayOf(PropTypes.shape({}).isRequired),
};

AssetModalContacts.defaultProps = {
  isPermalink: false,
  isCrypto: false,
  isBeneficiary: false,
  isMemorial: false,
  isViewOnly: false,
  accesses: [],
};

export default AssetModalContacts;
